// Shown instead of the game while the dashboard's maintenance mode is on, in the style of App52-OracleRefund. Battles
// already running finish first, and the Wallet stays open: a withdrawal is never blocked by maintenance.
import { useGame } from "../game.js";
import { go } from "../router.js";

export function Maintenance({ text }: { text: string }) {
  const { me, refresh } = useGame();
  return (
    <div className="screen">
      <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px" }}></div>
      <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
        <div className="top"><span className="chip chipN">MAINTENANCE</span></div>
        <div style={{ marginTop: "14px", display: "flex", justifyContent: "center" }}>
          <div style={{ width: "88px", height: "88px", borderRadius: "28px", background: "rgba(204,255,0,0.1)", border: "1px solid rgba(204,255,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 50px rgba(204,255,0,0.25)" }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#CCFF00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.5-.5-.5-2.5z"></path></svg>
          </div>
        </div>
        <h1 className="h1" style={{ marginTop: "22px", textAlign: "center" }}>Back soon</h1>
        <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px", overflowWrap: "anywhere" }}>{text}</p>
        <div className="g" style={{ marginTop: "22px", borderRadius: "20px", padding: "4px 0" }}>
          <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Your balance</span><span className="mono" style={{ fontSize: "14px", fontWeight: "800" }}>{me?.balance.available ?? "..."} USDT</span></div>
          <div className="div" style={{ margin: "0 14px" }}></div>
          <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Withdrawals</span><span className="lime" style={{ fontSize: "13px", fontWeight: "700" }}>Still open</span></div>
        </div>
        <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
          <button onClick={() => void refresh()} className="btnP">CHECK AGAIN</button>
          <button onClick={() => go("App28")} className="btnS">Open wallet</button>
        </div>
      </div>
    </div>
  );
}
